<style scoped>
/deep/.el-radio-button__orig-radio:checked + .el-radio-button__inner {
  color: #fff;
  background-color: #86b8bc;
  border-color: #86b8bc;
}
/deep/.el-input input:-webkit-autofill {
  background: none;
  box-shadow: 0 0 0px 1000px #fff inset !important;
}
/deep/.el-input__inner {
  border: none;
  border-bottom: 1px solid #bbb;
  border-radius: 0;
}
.bac-img {
  width: 35%;
  height: 100vh;
  background: #4fa1a4;
  position: relative;
}
.bac-img img {
  width: 68%;
  box-shadow: 4px 5px 12px rgba(0, 0, 0, 0.9) /*blur值为15px*/;
  margin-top: 10vh;
  left: 60px;
  border-radius: 10px;
}
.login-box {
  /* padding-top: 4vh; */
  /* padding-bottom: 4vh; */
  width: 100%;
  height: 100vh;
  box-sizing: border-box;
}
.login-right {
  float: right;
  position: relative;
  width: 460px;
  height: 100%;
  padding-top: 20vh;
  padding-bottom: 4vh;
  box-sizing: border-box;
  margin-right: calc(32.5% - 250px);
}
a {
  color: #4fa1a4;
}
/deep/.el-form-item__error {
  left: 15px;
}
.title-txt {
  font-size: 28px;
  margin-top: 30px;
  border-radius: 8px;
  margin-bottom: 20px;
}
.font-line {
  font-size: 26px !important;
  color: rgb(202, 201, 201);
}
.cen-sty {
  /* width: 1000px; */
  margin: 0 auto;
}

.logo-sty-img-big {
  width: 250px;
  /* height: 58px; */
}
.logo-sty-img-box {
  width: 250px;
  height: 58px;
  margin-left: 105px;
}

.login-sty {
  width: 460px;
  height: 200px;
  border-radius: 4px;
  margin-top: 20px;
}
.foot-sty {
  font-size: 12px;
  position: absolute;
  bottom: 0;
  right: 0;
  height: 30px;
  text-align: center;
}
.left-title {
  color: #fff;
  font-size: 22px;
  text-align: center;
  padding: 0 11%;
  font-weight: 500;
  line-height: 40px;
  margin-top: 8vh;
}
.desc-text {
  font-size: 15px;
  color: #fff;
  padding: 0 16% 0 16%;
  text-align: left;
  line-height: 28px;
}
.label-tip {
  text-align: left;
  padding-left: 15px;
  line-height: 13px;
  color: rgb(156, 156, 156);
}
.el-button + .el-button {
  margin-left: 0;
}
/deep/.el-input__inner::-webkit-input-placeholder {
  /* WebKit browsers 适配谷歌 */
  color: rgb(156, 156, 156);
}
/deep/.el-input__inner:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 适配火狐 */
  color: rgb(156, 156, 156);
}

/deep/.el-input__inner::-moz-placeholder {
  /* Mozilla Firefox 19+ 适配火狐 */
  color: rgb(156, 156, 156);
}

/deep/.el-input__inner:-ms-input-placeholder {
  /* Internet Explorer 10+  适配ie*/
  color: rgb(156, 156, 156);
}
/deep/.el-dialog {
  margin-left: calc(67.5% - 210px);
  border-radius: 8px;
}
.forget-sty {
  font-size: 14px;
  color: #676767;
  cursor: pointer;
}
.hqyzm {
  border-left: 1px solid #b2b2b2;
  width: 100px;
  height: 22px;
  font-size: 14px;
  line-height: 18px;
  color: #4fa1a4;
  padding-left: 10px;
  position: absolute;
  z-index: 5;
  right: 5px;
  margin-top: -30px;
  cursor: pointer;
  text-align: center;
}
.eye-k-sty {
  position: absolute;
  z-index: 9;
  right: 10px;
  margin-top: 10px;
  cursor: pointer;
}
</style>
<template>
  <div v-loading.fullscreen.lock="fullscreenLoading" v-show="showLogin"></div>
</template>
<script>
import cloneDeep from "lodash/cloneDeep";
import { appendUrlQuery, hasCertResultMarker } from '@/uilt/certResultMessage';
export default {
  data() {
    const ENV = location.href.indexOf('https://scm-operation.csyaoly.com') > -1?'pro': location.href.indexOf('https://scm-operation.cs4pl.com') > -1?'pre':'sit'
    return {
      radio1: '运营端',
      ruleForm: {
        logonUser: '',
        pwd: '',
        validateCode: 12345,
        platformGuid: '1e2409b7ef0b412c2bb84e38f8fe50ba',
        appSideGuid:  (ENV=='pre'|| ENV=='pro')? '03cb364e04d894a44cdb94273abffa13':'13312e94ceb8eb986b2885445530add0',
        userStatusType: 1,
      },
      // 正式
      // ruleForm: {
      //   logonUser:'',
      //   pwd: '',
      //   validateCode: 12345,
      //   platformGuid: '1e2409b7ef0b412c2bb84e38f8fe50ba',
      //   appSideGuid:'03cb364e04d894a44cdb94273abffa13',
      //   userStatusType: 1,
      // },
      rules: {
        logonUser: [
          { required: true, trigger: 'blur', message: '请输入账号' },
          { min: 1, max: 20, message: '请输入长度在 1-20 个字符', trigger: 'blur' },
          { validator: this.checkData, trigger: 'blur' },
        ],
        pwd: [
          { required: true, trigger: 'blur', message: '请输入密码' },
          { min: 6, max: 20, message: '请输入长度在 6-20 个字符', trigger: 'blur' },
          { validator: this.checkData, trigger: 'blur' },
        ],
      },
      fullscreenLoading: true,
      showLogin: true,
      menuList: [],
      buttonType: 1,
      btntext: '获取验证码',
      second: 120,
      disabled: false,
      password: 'password',
      password1: 'password',
      dialogFormVisible: false,
      ruleForm1: {
        mobileNo: '',
        smsCode: '',
        pwd: '',
        pwd2: '',
      },
    };
  },
  watch: {
    ruleForm: {
      handler(oldValue, newValue) {
        if (newValue.logonUser !== '' && newValue.pwd !== '') {
          this.buttonType = 1;
        } else {
          this.buttonType = 0;
        }
        console.log(oldValue, newValue);
      },
      deep: true,
    },
  },
  created() {
    localStorage.setItem('login_state', '2');
    if (this.$route.query.token) {
      localStorage.token = this.$route.query.token;
      localStorage.refreshToken = this.$route.query.refreshToken;
      localStorage.setItem(
        'appSideGuid',
        JSON.stringify(this.$route.query.appSideGuid || this.appSideGuid),
      );
      if (this.$route.query.tenantGuid) {
        localStorage.guid = this.$route.query.tenantGuid;
        localStorage.tenantGuid = this.$route.query.tenantGuid;
      }
      this.getCurrentuser();
      return
    }
    this.toLogin();
  },
  methods: {
    shPwd(flg) {
      this.password = flg;
    },
    shPwd1(flg) {
      this.password1 = flg;
    },
    forgetPwd() {
      let self = this;
      self.btntext = '获取验证码';
      clearInterval(self.clock);
      self.dialogFormVisible = true;
      self.ruleForm1.mobileNo = '';
      self.ruleForm1.smsCode = '';
      self.ruleForm1.pwd = '';
      self.ruleForm1.pwd2 = '';
    },
    runcode() {
      let self = this;
      let testTel = /^1[3456789]\d{9}$/;
      if (!self.ruleForm1.mobileNo || !testTel.test(self.ruleForm1.mobileNo)) {
        self.$message.error('请输入您的正确手机号码！');
        return false;
      }
      if (self.disabled) {
        return false;
      }
      self.api
        .get(
          `/${serverConfig.msCommonAdminPlatformAuthService}/user/data/get-msg-code?mobileNo=` +
            self.ruleForm1.mobileNo +
            '&terminalType=' +
            '1',
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.$message.success('发送验证码成功');
            self.clock = setInterval(self.sendCode, 1000);
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    sendCode() {
      let self = this;
      self.second--;
      self.disabled = true;
      self.btntext = self.second + '秒后可获取';
      if (self.second == 0) {
        clearInterval(self.clock);
        self.second = 120;
        self.btntext = '获取验证码';
        self.disabled = false;
      }
    },
    resetPwd() {
      let self = this;
      let testTel = /^1[345789]\d{9}$/;
      if (!self.ruleForm1.mobileNo || !testTel.test(self.ruleForm1.mobileNo)) {
        self.$message.error('请输入您的正确手机号码！');
        return;
      }
      if (self.ruleForm1.pwd == '') {
        self.$message.error('请输入密码！');
        return false;
      }
      if (self.ruleForm1.pwd.length < 6) {
        self.$message.error('密码长度至少6位！');
        return false;
      }
      if (self.ruleForm1.pwd !== self.ruleForm1.pwd2) {
        self.$message.error('两次密码请填写一样！');
        return false;
      }
      let query = {
        mobileNo: self.ruleForm1.mobileNo,
        pwd: self.$md5(self.ruleForm1.pwd),
        pwd2: self.$md5(self.ruleForm1.pwd2),
        smsCode: self.ruleForm1.smsCode,
      };
      self.api.put(`/${serverConfig.msCommonAdminPlatformAuthService}/user/data/resetPwd-byMsgCode`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.$message.success('密码修改成功，请重新登录');
          self.dialogFormVisible = false;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    //验证数字
    checkNumber(rule, value, callback) {
      if (value) {
        if (/[^\d]/g.test(value)) {
          callback(new Error('请输入纯数字!'));
        } else {
          callback();
        }
      }
      callback();
    },
    //验证字符
    checkData(rule, value, callback) {
      if (value) {
        if (/[\u4E00-\u9FA5]/g.test(value)) {
          callback(new Error('请输入字符!'));
        } else {
          callback();
        }
      }
      callback();
    },
    changeLink() {
      let self = this;
      if (self.radio1 == '企业端') {
        window.location.href = 'https://scm.csyaoly.com/Login';
      } else {
        window.location.href = 'https://scm-operation.csyaoly.com/login';
      }
    },
    toLogin() {
      var self = this;
      self.api
        .post(
          '/csbr-zuul/user/login?' +
            `logonUser=` +
            self.$route.query.username +
            `&platformGuid=` +
            self.ruleForm.platformGuid +
            `&pwd=` +
            self.$route.query.password +
            `&userStatusType=` +
            self.ruleForm.userStatusType +
            `&validateCode=` +
            self.ruleForm.validateCode,
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            // window.sessionStorage.setItem('token',res.data.data.token);
            self.$store.commit('$_setStorage', res.data.data.token);
            self.getCurrentuser();
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    async getCurrentuser() {
      var self = this;
      var tenantGuid = this.$route.query.tenantGuid;
      localStorage.tenantGuid = tenantGuid;
      localStorage.guid = tenantGuid;
      self.$store.commit('$_setTenantGuid', tenantGuid);
      self.getAddRedis(tenantGuid);
      await self.getCurrentuserInfo(tenantGuid);
      await self.getCurrentstaff(tenantGuid);
      await self.getCodeList();
      self.getMenuList(tenantGuid);
    },
    async getCurrentuserInfo(tenantGuid) {
      let self = this;
      const { data } = await self.api.get(
        `/${serverConfig.msCustomerService}/tenant/data/get-tenants-by-currentuser`
      );
      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        self.$message.error(data.msg);
        return;
      }
      if (data.data && data.data.length) {
        const currentTenant =
          data.data.find((item) => item.guid == tenantGuid) || data.data[0];
        localStorage.systemEnvironment = currentTenant.systemEnvironment;
        localStorage.supertubeFlag = currentTenant.supertubeFlag;
      }
    },
    async getCodeList() {
      let self = this;
      const { data } = await self.api.get(
        `/${serverConfig.msConfigureService}/dict/data/get-all`
      );
      if (data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
        localStorage.codeList = JSON.stringify(data.data);
      } else {
        self.$message.error(data.msg);
      }
    },
    async getCurrentstaff(tenantGuid) {
      let self = this;
      await self.api.get(`/${serverConfig.msPersonnelService}/staff/data/get-currentstaff?` + `tenantGuid=` + tenantGuid).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.ruleForm.userGuid = res.data.data.userGuid;
          // self.$store.commit('$_setUserId',res.data.data.userGuid);
          localStorage.setItem('userInfo', JSON.stringify(res.data.data));
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getMenuList(tenantGuid) {
      let self = this;
      let productGuid = this.$route.query.productGuid;
      let tenantProductGuid = this.$route.query.tenantProductGuid;
      var reqUrl;
      if (productGuid) {
        reqUrl =
          `/${serverConfig.msCommonAdminPlatformAuthService}/menu/data/get-menu-by-currentuser?` +
          `appType=01&tenantGuid=` +
          tenantGuid +
          `&productGuid=` +
          productGuid + `&appSideIdentifier=scm_operative`;
      } else {
        reqUrl =
          `/${serverConfig.msCommonAdminPlatformAuthService}/menu/data/get-menu-by-currentuser?` + `appType=01&tenantGuid=` + tenantGuid+ `&appSideIdentifier=scm_operative`;
      }
      self.api.get(reqUrl).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          localStorage.setItem(
            'wynToken',
              JSON.stringify('670550ae1460a86607190cd98b36eea4dcf0069a7e9d1f8c3af08b4b6936e6ef'),
          );
          self.menuList = res.data.data;
          localStorage.setItem(
            'allMenuList',
            JSON.stringify(cloneDeep(res.data.data)),
          );
          self.menuList.forEach(function (i, idx) {
            // if (i.externalLinkMark == '01') {
            //   i.src = i.path;
            //   i.path = '/reportQuery-' + idx;
              if (i.children != null && i.children != '') {
                i.children.forEach(function (j, index) {
                  index = index + 1;
                  if (j.externalLinkMark == '01') {
                    j.src = j.path;
                    j.path = '/reportQuery-' + idx + index;
                  }
                });
              }
           // }
          });
          if (res.data.data[0].menuName == '主页') {
            if (
              res.data.data[0].path == '/SZ_homePageReportNew' &&
              res.data.data[0].children
            ) {
              localStorage.setItem(
                'reportMenuList',
                JSON.stringify(res.data.data[0].children),
              );
            }
            self.menuList = self.menuList.slice(1);
          }
          let newList = [];
          self.menuList.forEach((item, index) => {
            if (item.menuName.length != 2) {
              newList.push(item);
            }
          });
          self.menuList = newList;
          localStorage.setItem('menuList', JSON.stringify(self.menuList));
          // console.log(res.data.data)
          // return;
          // if (res.data.data[0].children[0].externalLinkMark == '01') {
          //   if (productGuid) {
          //     productGuid = tenantProductGuid || productGuid;
          //     self.$router.push('/reportQuery-01' + '?productGuid=' + productGuid);
          //   } else {
          //     self.$router.push('/reportQuery-01');
          //   }
          // } else {
          if (self.$route.query.path) {
            if (productGuid) {
              productGuid = tenantProductGuid || productGuid;
              if (hasCertResultMarker(self.$route.query.path, self.$route.query.certResultCode)) {
                self.$router.push(appendUrlQuery(self.$route.query.path, 'productGuid', productGuid));
              } else if (self.$route.query.path.indexOf('?') > -1) {
                self.$router.push(decodeURIComponent(self.$route.query.path + '&productGuid=' + productGuid));
              } else {
                self.$router.push(decodeURIComponent(self.$route.query.path + '?productGuid=' + productGuid));
              }

            } else {
              self.$router.push(hasCertResultMarker(self.$route.query.path, self.$route.query.certResultCode)
                ? self.$route.query.path : decodeURIComponent(self.$route.query.path));
            }
          } else {
            if (productGuid) {
              productGuid = tenantProductGuid || productGuid;
              self.$router.push(
                (self.menuList[0].children && self.menuList[0].children[0].path + '?productGuid=' + productGuid) ||
                self.menuList[0].path + '?productGuid=' + productGuid,
              );
            } else {
              self.$router.push(
                (self.menuList[0].children && self.menuList[0].children[0].path) || self.menuList[0].path,
              );
            }
          }
        }
      });
    },
    getAddRedis(tenantGuid) {
      let self = this;
      self.api
        .get(`/${serverConfig.msPersonnelService}/staff/data/add-currentstaff-to-redis?tenantGuid=${tenantGuid}`)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
};
</script>
